<template>
  <div id="AstrolabeView" class="background-container">
    <header>
      <!-- <h1>星雲鑑专业星盘系统</h1>
      <div class="subtitle">权威数据发布</div> -->
      <TopBar
        @astrolabe-type-change="handleAstrolabeTypeChange"
        @toggle-score-table="scoreTableVisible = $event"
        @save-image="saveImage"
        @open-phase-search="handleOpenPhaseSearch"
        @open-feature-purchase="handleOpenFeaturePurchase"
        :scoreTableVisible="scoreTableVisible"
        :permissionMode="currentPermissionMode"
        :permissions="resolvedPermissions"
      />
    </header>

    <div class="content">
      <section class="canvas-section">
        <!-- 无星盘权限时的持久空态提示：比一次性 toast 更明确，
             配合画布侧的数据守卫，画布保持空白而不是只剩一个白色底圆 -->
        <div v-if="!hasPermission('basic_astrolabe')" class="canvas-permission-notice">
          <!-- vip=3（账号已禁用）：无论会员日期是否过期，都只提示联系客服，
               既不显示 vip=2 的到期续费引导，也不给支付入口 -->
          <template v-if="isMembershipDisabled">
            <div>当前会员状态被禁用，请联系客服</div>
          </template>
          <template v-else>
            <!-- 会员租期已过：vip=1（有过期日期）与 vip=2 共用同一套提示与付款弹窗，
                 文案与续费入口保持不变 -->
            <template v-if="isMembershipExpired">
              <div>您的会员租期已过，星盘功能已暂停，请重新支付年租后继续使用</div>
              <div v-if="membershipExpiryText" class="canvas-permission-expiry">会员到期时间：{{ membershipExpiryText }}</div>
              <el-button class="canvas-permission-renew-btn" type="primary" size="small" @click="openRenewDialog">重新支付年租</el-button>
            </template>
            <template v-else>
              当前账号暂无星盘使用权限，请联系客服开通后重试
              <!-- vip=1（普通会员）且没有有效会员日期：原有文字提示保留，
                   额外给一个支付入口 —— 点击后返回主页，由主页已有的年费支付弹窗承接 -->
              <el-button
                v-if="isNormalVipMember"
                class="canvas-permission-renew-btn"
                type="primary"
                size="small"
                @click="goHomeAndOpenVipPurchase">支付年租</el-button>
            </template>
          </template>
        </div>
        <AstrolabeCanvas
          ref="astrolabeCanvas"
          :astrolabeData="astrolabeData"
          :loading="loading"
          :renderRevision="canvasRenderTracker.issuedRevision"
          :info="computedInfo"
          :planetList="planetList"
          :fateData="fateData"
          :starList="starList"
          :logicPointList="logicPointList"
          :scoreTableData="planetPowerList"
          :scoreTableVisible="scoreTableVisible"
          :permissions="resolvedPermissions"
          :show-scale-circle="showScale"
          :show-fix-ring="showFixRing"
          :zuoshan="requestData.zuoshan"
          :show-zuoshan-arrow="requestData.astrolabeType === 'horizon'"
          :toleranceMatrix="requestData.toleranceMatrix"
          :phaseToleranceRows="requestData.phaseToleranceRows"
          :defaultMatrix="defaultMatrix"
          :selectedPlanetIds="selectedPlanets"
          :selectedStarIds="selectedStars"
          :selectedPointIds="selectedPoints"
          :selectedMidpointPairs="selectedMidpoints"
          :natalAstrolabeData="visibleNatalAstrolabeData"
          :selectedPhases="selectedMajorPhases.concat(selectedMinorPhases)"
          :phaseCellSelections="phaseCellSelections"
          :eh-flag="ehFlag"
          :tooltipRemarkMap="requestData.tooltipRemarkMap"
          :tooltip-interaction-mode="tooltipInteractionMode"
          :starToleranceMap="requestData.starToleranceMap"
          @render-complete="handleCanvasRenderComplete"
          @update-planets="updatePlanets"
          @update-stars="updateStars"
          @update-points="updateLogicPoints"
          @update-tolerance-matrix="updateToleranceMatrix"
          @update-phase-tolerance-rows="updatePhaseToleranceRows"
          @update-star-tolerance-matrix="updateStarToleranceMatrix"
          @update-phases="updatePhases"
          @update-midpoints="updateMidpoints"
          @update-remark="updateTooltipRemark"
          @request-save-config="requestSaveConfigFromDialog"
          @open-feature-purchase="handleConfigGatePurchase"
        />

        <!-- <div class="button-row">
          <button style="background-color: #2ecc71" @click="generateAstrolabe">生成星盘</button>
          <button style="background-color: #e74c3c" @click="stop">停止</button>
          <button style="background-color: #3498db" @click="qianjing">前进</button>
        </div> -->
        <!--功能栏（可自由拖拽：按住左侧手柄即可移动，样式见下方 .feature-toolbar）-->
        <div class="feature-toolbar-slot">
          <div
            ref="featureToolbar"
            class="feature-toolbar"
            :class="{ 'is-dragging': isDraggingFeatureToolbar }"
            :style="featureToolbarDragStyle"
          >
            <!--拖拽手柄：只允许从手柄起拖，避免抢走按钮点击与输入框的文本操作-->
            <div class="feature-toolbar-handle" title="按住拖动" @pointerdown="handleFeatureToolbarPointerDown">
              <span class="el-icon-rank" />
            </div>
            <!--按钮区容器-->
            <div style="display: flex; align-items: center;">
              <div style="width: 135px; height: 60px;float: left;" v-for="one in filteredFeatureList" :key="one.icon">
                <!--按钮图标-->
                <div :id="one.icon" :class="one.className || 'featureList-row'"  :style="one.style" @click="handleFeatureClick(one, one.icon)">
                  <span :class="getFeatureControlState(one).icon" style="font-size: 28px; display: flex; align-items: center; justify-content: center; height: 40px;" />
                </div>
                <!--文字-->
                <div style="width: 90%; font-size: 14px; font-weight: 500;text-align: center; margin-top: 5px">{{getFeatureControlState(one).label}}</div>
              </div>
            </div>
            <!--步进间隔输入框和单位选择-->
            <div style="margin-left: 20px; display: flex; align-items: center; white-space: nowrap;">
              <label style="font-size: 14px; margin-right: 8px; line-height: 30px;">步进间隔:</label>
              <input
                type="number"
                v-model.number="stepValue"
                min="1"
                style="width: 60px; height: 30px; padding: 2px; border: 1px solid #ccc; border-radius: 4px; font-size: 14px; text-align: center;"
              />
              <select
                v-model="stepUnit"
                style="margin-left: 5px; width: 60px; height: 30px; padding: 2px; border: 1px solid #ccc; border-radius: 4px; font-size: 14px;"
              >
                <option value="year">年</option>
                <option value="month">月</option>
                <option value="day">日</option>
                <option value="hour">时</option>
                <option value="minute">分</option>
                <option value="second">秒</option>
              </select>
            </div>
            <!--等分宫位开关（调试用，隐藏）-->
            <div v-if="false" style="margin-left: 20px; display: flex; align-items: center;">
              <input type="checkbox" id="ehFlag" v-model="ehFlag" style="width: 18px; height: 18px; margin-right: 5px;" />
              <label for="ehFlag" style="font-size: 14px; cursor: pointer;">等分宫位</label>
            </div>
          </div>
        </div>
      </section>

      <AstrolabeForm
        :requestData="requestData"
        :starList="starList"
        :fateData="fateData"
        :natalFateData="natalFateData"
        @update-info="updateInfo"
        @request-natal-fate-update="scheduleNatalFateDataUpdate"
        @natal-panel-visibility-change="handleNatalPanelVisibilityChange"
      />
    </div>

    <!-- 会员租期已过提示弹窗（仅在无星盘权限且登录态里有已过期会员有效期时出现） -->
    <el-dialog
      title="会员租期已过"
      :visible.sync="renewDialogVisible"
      width="420px"
      append-to-body>
      <div class="renew-dialog-body">
        <p class="renew-dialog-main">尊敬的用户，您的租期已过，请重新支付年租。</p>
        <p v-if="membershipExpiryText" class="renew-dialog-sub">会员到期时间：{{ membershipExpiryText }}</p>
        <p class="renew-dialog-sub">支付成功后立即恢复星盘功能，有效期一年。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="renewDialogVisible = false">稍后再说</el-button>
        <el-button type="primary" @click="handleRenewPay">支付年租</el-button>
      </span>
    </el-dialog>

    <!-- 会员购买弹窗：与首页「普通会员」共用同一支付链路 -->
    <vip-purchase-dialog
      :visible.sync="vipPurchaseVisible"
      title="支付年租"
      intro="尊敬的用户，您的租期已过，请重新支付年租。"
      pay-button-text="支付年租"
      success-message="支付成功，会员已开通，页面将自动刷新…"
    />

    <!-- 开通功能弹窗：11 项可购买权限（9 项扫码付费 + 点报警/面报警两个 0 元项），
         付费项扫码支付后自动开通，0 元项点击后直接开通一年并锁卡 -->
    <feature-purchase-dialog
      :visible.sync="featurePurchaseVisible"
      :user-id="currentUserId"
      :default-key="featurePurchaseDefaultKey"
      @paid="handleFeaturePurchasePaid"
    />

    <!-- 相位搜索弹窗：日期区间 + 和谐相位阈值 → 「日期 | 相位」结果表 -->
    <phase-search-dialog :visible.sync="phaseSearchVisible" />

    <footer>
      星雲鑑星盘系统 | 基于专业天文算法 | 宫位制: {{ getHouseSystemName(requestData.hsys) }}
    </footer>
  </div>
</template>

<script>
import AstrolabeCanvas from '../components/astrolabe/AstrolabeCanvas.vue'
import AstrolabeForm from '../components/astrolabe/AstrolabeForm.vue'
import PermissionService from '@/services/PermissionService'
import api from '../services/api'
import TopBar from '../components/TopBar.vue'
import VipPurchaseDialog from '@/features/tianxing/components/VipPurchaseDialog.vue'
import FeaturePurchaseDialog from '@/features/tianxing/components/FeaturePurchaseDialog.vue'
import { MessageBox } from 'element-ui'
// 开通功能目录：用于把「配置入口无权限」的引导定位到对应权益（取中文名/判权口径）
const purchaseCatalog = require('@/features/tianxing/utils/permissionPurchaseCatalog')
import PhaseSearchDialog from '../components/astrolabe/PhaseSearchDialog.vue'
import html2canvas from 'html2canvas'

const phaseToleranceProtocol = require('../utils/phaseToleranceProtocol')
const starTolerance = require('../utils/starTolerance')
const astrolabeRequestPayload = require('../utils/astrolabeRequestPayload')
// 恒星管控（受管控恒星恒参与请求、默认不上画布、按钮默认屏蔽）
const starControl = require('../features/tianxing/utils/starControl')
const astrolabeBundleResponse = require('../utils/astrolabeBundleResponse')
const { createAstrolabeImageExportOptions } = require('../utils/astrolabeImageExportOptions')
const {
  shouldSkipRepeatedAutoSave,
  resolveAutoSaveFailureFingerprint
} = require('../utils/astrolabeConfigSaveGuards')
const {
  createRenderTracker,
  issueRenderRevision,
  waitForRenderRevision,
  markRenderRevisionRendered
} = require('../utils/astrolabeRenderTracker')
const { buildTooltipRemarkStorageKey } = require('../utils/tooltipRemarkKeys')

// 无 basic_astrolabe 权限时用于中断首屏初始化链路的哨兵值（属预期分支，不是真实错误）
const NO_ASTROLABE_PERMISSION = 'NO_ASTROLABE_PERMISSION'

// 星盘相关接口的权限校验由后端完成，无权限统一返回 403
// （响应体形如 Permission denied: basic_astrolabe, userId=xxx）
function isAstrolabePermissionDenied (error) {
  return Boolean(error && error.response && error.response.status === 403)
}
const {
  adjustAstrolabeDateTime,
  createNavigationControls,
  getNavigationControlState,
  resolvePlaybackDirection,
  runSerialPlayback
} = require('../utils/astrolabeDateNavigation')
const { formatFateDisplayData, formatLunarDateDisplay } = require('../utils/fateDisplayFormat')
// 万年历农历（本地独立计算，北京时间 24:00 口径）——与后端「星雲鑑历」（23:00 口径）区分
const wannianliLunar = require('../utils/wannianliLunar')
const userContext = require('../services/userContext')
// 登录态权威刷新入口（按 id + auth_code 请求 /yljx/public/login，写回即广播）
const refreshUser = require('../features/tianxing/utils/refreshTianxingUser')

const LEGACY_NEBULA_LOGIC_POINT_ID = 46
const FRONTEND_DUMMY_YOUYI_POINT_ID = 9000046

// 命理（农历/四柱/真太阳时）请求的防抖时长：日期、时间、经纬度都是逐字符输入，
// 每次按键都会触发一次命理刷新，这里把一次输入过程收敛为「停止输入 300ms 后」的
// 最后一次请求，避免中间态请求与最终结果互相干扰。
const FATE_UPDATE_DEBOUNCE_MS = 300

export default {
  name: 'AstrolabeView',
  components: {
    AstrolabeCanvas,
    AstrolabeForm,
    TopBar,
    // 会员购买弹窗：与首页「普通会员」共用同一支付链路（会员租期已过时用于续费）
    VipPurchaseDialog,
    // 开通功能弹窗：9 项可扫码购买权限 + 微信支付二维码
    FeaturePurchaseDialog,
    // 相位搜索弹窗：日期区间 + 和谐相位阈值 → 「日期 | 相位」结果表
    PhaseSearchDialog
  },
  mounted () {
    this.initializePermissionMode()
    this.currentUserId = userContext.getCurrentUserId()
    // 订阅全局登录态变更（支付开通 / 换绑 / 刷新用户信息）→ 就地重读权限与会员信息
    this.unsubscribeTianxingUser = userContext.subscribeTianxingUser(user => {
      this.handleStoredTianxingUserChanged(user)
    })
    // 进入星盘页即拉一次后端权威用户信息（失败静默），确保权限/会员/报警权益是最新的
    this.refreshStoredTianxingUser()
    // 手机扫码付款后回到本页（重新聚焦 / 回到前台）也刷新一次
    if (typeof window !== 'undefined' && window.addEventListener) {
      window.addEventListener('focus', this.handleWindowFocusRefresh)
    }
    if (typeof document !== 'undefined' && document.addEventListener) {
      document.addEventListener('visibilitychange', this.handleVisibilityChangeRefresh)
    }
    // 万年历农历（前端本地独立计算）：主盘/本命盘的公历日期一变就重算，
    // 纯本地、不发请求、不写回 date，因此不影响星盘与四柱计算
    this.unwatchWannianliLunar = this.$watch(
      () => `${this.requestData.date}|${this.requestData.natalDate}`,
      () => this.syncWannianliLunarDate(),
      { immediate: true }
    )

    // 星盘页 userId 只有两种来源：域名参数（/onlineChart?userId=893）与全局登录态
    // （天星首页登录后写入 localStorage.user，用户主键 id）。两者都没有时，
    // 不再继续 bootstrap，直接提示用户先登录账号再使用。
    if (!this.currentUserId) {
      this.notifyLoginRequired()
      return
    }

    // 第一批先把 bootstrap 作为统一入口：先拿 userId / 权限 / 配置，再进入后续列表拉取与首屏生成。
    this.bootstrapUserSession()
      .then(() => {
        // 无 basic_astrolabe 权限：直接进入友好空态，不再发起恒星/行星/逻辑点/真太阳时
        // 这一连串请求 —— 它们同样受该权限约束，无权限时只会连环 403，
        // 而前端此前没有任何提示、还会反复重试（线上日志里能看到同一秒多次 403）。
        if (!this.hasPermission('basic_astrolabe')) {
          this.handleAstrolabePermissionDenied()
          return Promise.reject(NO_ASTROLABE_PERMISSION)
        }
        return Promise.all([
          this.fetchStarList(),
          this.fetchPlanetList(),
          this.fetchLogicPointList(),
          this.updateFateData()
        ])
      })
      .then(() => {
        this.generateAstrolabe()
      })
      .catch(error => {
        // 无权限分支已在上面提示并切到空态，这里只兜底其它初始化异常
        if (error === NO_ASTROLABE_PERMISSION) {
          return
        }
        console.error('[AstrolabeView] 首屏初始化失败:', error)
      })
  },
  data () {
    const now = new Date()
    const dateStr = now.toISOString().split('T')[0].replace(/-/g, '/')
    const timeStr = now.toTimeString().substr(0, 8)
    const defaultMatrix = phaseToleranceProtocol.getDefaultLegacyToleranceMatrix()
    const defaultPhaseToleranceRows = phaseToleranceProtocol.convertLegacyMatrixToPhaseToleranceRows(defaultMatrix)
    const defaultSelectedPlanets = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 1000014, 1000015, 1000016, 1000017, 1000018, 1000019]
    // 受管控恒星恒在已选列表中（用户无法通过 UI 取消）
    const defaultSelectedStars = starControl.withControlledStars([0])
    const defaultSelectedPoints = [0]
    const defaultSelectedMajorPhases = [
      { name: '合相', ruleIndex: 0, selected: true },
      { name: '二分相', ruleIndex: 10, selected: true },
      { name: '四分相', ruleIndex: 5, selected: true },
      { name: '三分相', ruleIndex: 6, selected: true },
      { name: '六分相', ruleIndex: 3, selected: true }
    ]
    const defaultSelectedMinorPhases = []
    const defaultSelectedMidpoints = []
    const defaultStepValue = 4
    const defaultStepUnit = 'minute'
    const configState = astrolabeRequestPayload.buildDefaultConfigState({
      defaultMatrix,
      defaultPhaseToleranceRows,
      defaultSelectedPlanets,
      defaultSelectedStars,
      defaultSelectedPoints,
      defaultSelectedMajorPhases,
      defaultSelectedMinorPhases,
      defaultSelectedMidpoints,
      defaultStepValue,
      defaultStepUnit
    })
    const runtimeState = astrolabeRequestPayload.buildDefaultRuntimeState({
      dateStr,
      timeStr
    })
    const requestData = astrolabeRequestPayload.buildRequestDataFromPageState({
      configState,
      runtimeState
    })

    return {
      // 功能栏拖拽（与「行星力量」悬浮表格同一套做法：Pointer Events + 增量位移）
      // null 表示还没拖过：保持原静态布局（居中在画布下方、随窗口自适应）；
      // 一旦拖动就切换为绝对定位并固定坐标，之后位置只由用户拖动决定。
      featureToolbarPosition: null,
      isDraggingFeatureToolbar: false,
      featureToolbarDragStart: { pointerX: 0, pointerY: 0, posX: 0, posY: 0 },
      // 当前捕获指针的手柄元素，拖动结束后用于解绑监听
      featureToolbarDragTarget: null,
      featureList: [
        {
          label: '生成星盘', // 名字
          icon: 'el-icon-refresh', // 图标
          method: this.generateAstrolabe, // 方法
          style: { backgroundColor: '#2ecc71' }, // 制定CSS-优于class样式
          option: [],
          permission: 'basic_astrolabe' // 基础权限
        },
        ...createNavigationControls().map(control => ({
          ...control,
          method: this.toggleAutoPlay,
          option: [String(control.direction)],
          permission: 'basic_astrolabe'
        }))
      ],
      currentUserId: userContext.getCurrentUserId(),
      currentPermissionMode: PermissionService.getPermissionMode(),
      resolvedPermissions: PermissionService.getPermissions(),
      configState,
      runtimeState,
      configDirty: false,
      lastConfigChangeReason: '',
      autoSaveTimer: null,
      configSaveInFlight: false,
      pendingAutoSaveReason: '',
      lastAutoSaveFailureFingerprint: '',
      showNatalChartOnCanvas: false,
      suspendConfigWatch: false,
      // 请求参数（当前仍保留为页面工作态视图模型，后续逐步从 configState / runtimeState 衍生）
      requestData,
      tooltipInteractionMode: 'click',

      logicPointList: [], // 存储逻辑点列表
      planetList: [], // 存储行星列表
      starList: [], // 存储恒星列表
      selectedPlanets: defaultSelectedPlanets, // 日月水金火木土天海冥 + 计都 + MC + ASC + 福点 + 宿命点 + 反宿命点 + 春分点
      selectedStars: defaultSelectedStars,
      selectedPoints: defaultSelectedPoints,
      // 相位选择（按原列顺序：合相,二分相,四分相,三分相,六分相,30°,45°,135°,150°,72°,144°）
      selectedMajorPhases: defaultSelectedMajorPhases,
      selectedMinorPhases: defaultSelectedMinorPhases,
      // 单元格选择状态（用于前端过滤相位线）
      phaseCellSelections: [],
      // 催贵公式选中的行星对
      selectedMidpoints: defaultSelectedMidpoints,
      // 配置加载状态
      configLoaded: false,
      // 等分宫位开关（true=使用等分宫位绘制，false=使用标准绘制）
      ehFlag: true,

      planetPowerList: [], // 存储行星力量列表

      // 无星盘权限的提示是否已弹出过：初始化与应用运行期的多个入口都会调用
      // handleAstrolabePermissionDenied，这里保证只提示一次，避免连环弹窗。
      astrolabePermissionNotified: false,

      // 命理/农历接口本轮失败是否已提示过：日期字段逐字符输入会连续触发请求，
      // 失败后不再重复弹提示，等下一次成功计算后再重置。
      fateFailureNotified: false,
      // 本命盘命理/农历失败提示位，口径与主盘一致
      natalFateFailureNotified: false,

      astrolabeData: null,
      // 本命盘数据（用于黄道盘外圈）
      natalAstrolabeData: null,
      generateRequestSeq: 0,
      // 命理请求序号：日期/时间/坐标逐字符输入会连发多次请求，只允许序号最新的一次响应
      // 写入界面，否则过期响应会把正确结果覆盖成中间态（线上曾出现「输入 1996 显示成己卯年」）。
      fateRequestSeq: 0,
      // 本命盘命理请求序号，作用同上
      natalFateRequestSeq: 0,
      // 命理请求防抖句柄（主盘 / 本命盘各一个）
      fateUpdateTimer: null,
      natalFateUpdateTimer: null,
      // 请求加载动画
      loading: false,
      canvasRenderTracker: createRenderTracker(),
      autoPlayLoopSeq: 0,

      // 新增：控制分数表格的显示状态
      scoreTableVisible: true,
      // 新增：控制外圈刻度环的显示状态
      showScale: false,
      // 新增：控制最外圈字符环显示状态
      showFixRing: false,
      // 命理信息
      fateData: {},
      // 本命盘命理信息
      natalFateData: {},
      // 行星相位容许误差默认矩阵
      // 口径与后端 PhaseToleranceResolver 保持一致，兼容 legacy 行序并为 phaseToleranceRows 提供默认源
      defaultMatrix,
      // 步进值
      stepValue: 4,
      // 步进单位：year, month, day, hour, minute, second
      stepUnit: 'minute',
      // 自动播放方向（-1 后退，0 停止，1 前进）
      autoPlayDirection: 0,
      // 定时器
      timer: null,
      autoPlayWaitResolver: null,
      autoPlayRunPromise: null,
      // 会员租期续费：提示弹窗与公共购买弹窗的显示控制
      renewDialogVisible: false,
      vipPurchaseVisible: false,
      // 「开通功能」弹窗显示控制
      featurePurchaseVisible: false,
      // 「开通功能」弹窗打开时希望定位高亮的权益 key（如相位搜索无权限时引导到 harmonious_phase_search）
      featurePurchaseDefaultKey: '',
      // 「相位搜索」弹窗显示控制
      phaseSearchVisible: false,
      // 本次会话是否已自动弹过「租期已过」提示（避免 bootstrap 与 403 两条路径重复弹）
      renewPromptShown: false,
      // 会员到期时间（登录态 express_time，进入判定前由 refreshMembershipState 刷新）
      membershipExpiry: '',
      // 会员等级（登录态 vip：'1'=普通会员、'2'=VIP、'3'=已禁用），与到期时间一起刷新
      membershipVip: ''
    }
  },
  computed: {
    /**
       * 功能栏的定位样式
       *
       * 还没拖动过时返回 null：沿用 CSS 里的静态布局（画布下方居中、随窗口自适应）。
       * 拖动后返回绝对定位，把位置固定在用户拖到的地方（随页面滚动，与「行星力量」表格一致）。
       */
    featureToolbarDragStyle () {
      if (!this.featureToolbarPosition) return null

      return {
        position: 'absolute',
        left: `${this.featureToolbarPosition.x}px`,
        top: `${this.featureToolbarPosition.y}px`,
        // 绝对定位后原来的 margin: 10px auto 0 会把位置带偏，拖动时统一清零
        margin: 0,
        // 与「行星力量」表格同级，低于 el-dialog（2000 起）
        zIndex: 1000
      }
    },
    // 过滤后的功能列表（根据权限）
    filteredFeatureList () {
      return this.featureList.filter(f => this.hasPermission(f.permission))
    },
    /**
     * 计算属性：实时组合表单数据和农历数据
     */
    computedInfo () {
      return {
        name: this.requestData.name,
        address: this.requestData.address,
        solarDate: this.requestData.date,
        beijingTime: this.requestData.time,
        timezone: this.formatTimezoneLabel(this.requestData.timezone),
        // 信息面板「星雲鑑历」= 后端 /fateCalculate 口径（2026-10-13 起与万年历农历分离口径）
        lunarDate: formatLunarDateDisplay(this.requestData.lunarDateXYJ),
        // 信息面板「农历」= 万年历口径，**与右侧表单的「农历」行同源**（requestData.lunarDate），
        // 因此表单里手改农历、或日期变化重算，左侧这一行都会同步（2026-10-15 新增）
        wannianliLunarDate: formatLunarDateDisplay(this.requestData.lunarDate),
        // lunarTime: this.requestData.lunarTime,
        longitude: `${this.requestData.longitudeDeg}°${this.requestData.longitudeMin}'${this.requestData.longitudeSec}"`,
        latitude: `${this.requestData.latitudeDeg}°${this.requestData.latitudeMin}'${this.requestData.latitudeSec}"`,
        hsys: this.getHouseSystemName(this.requestData.hsys),
        astrolabeType: this.getAstrolabeTypeName(this.requestData.astrolabeType)
      }
    },
    visibleNatalAstrolabeData () {
      return this.showNatalChartOnCanvas ? this.natalAstrolabeData : null
    },
    isAutoPlaying () {
      return this.autoPlayDirection !== 0
    },
    /**
     * 会员到期时间原文（登录态 localStorage.user.express_time，取不到返回空串）
     *
     * 注意：这里读的是 data.membershipExpiry（由 refreshMembershipState() 主动刷新），
     * 而不是直接在 computed 里访问 localStorage —— computed 没有响应式依赖时会被永久缓存，
     * 登录态在页面加载后变化就不会再更新。
     */
    membershipExpiryText () {
      return this.membershipExpiry || ''
    },
    /**
     * 会员租期是否已过期
     *
     * 口径：登录态里有 express_time 且该时间已过。express_time 为空 / 无该字段
     * （从未开通、或后台已清空）不算「租期已过」，维持原有的通用无权限文案。
     * 与后端口径一致：登录时后端会把已过期用户的 vip 降为普通会员。
     */
    isMembershipExpired () {
      const expiry = this.membershipExpiry
      if (!expiry) return false
      return !userContext.isEntitlementActive(expiry)
    },
    /**
     * 账号是否已被禁用（登录态 vip = 3）
     *
     * vip=3 是后台对账号的禁用标记，优先级高于会员日期：
     * 这类账号无论日期是否过期，都只提示「当前会员状态被禁用，请联系客服」，
     * 也不参与「租期已过」的续费引导与自动弹窗。
     */
    isMembershipDisabled () {
      return String(this.membershipVip) === '3'
    },
    /**
     * 是否为普通会员（登录态 vip = 1）
     *
     * vip=1 分两种：
     *   - 没有有效会员日期：保留原有文字提示，额外给出「支付年租」入口，
     *     点击后返回主页复用主页已有的年费支付弹窗；
     *   - 有过期会员日期：与 vip=2 过期走同一套续费提示 + 付款弹窗（不额外加按钮）。
     * 因此这里只在「未过期」分支（即没有有效日期）里配合渲染入口。
     */
    isNormalVipMember () {
      return String(this.membershipVip) === '1'
    }
  },
  watch: {
    // 「开通功能」弹窗关闭后清掉一次性定位 key，避免下次手动打开时仍停留在上次的引导项
    featurePurchaseVisible (visible) {
      if (!visible) {
        this.featurePurchaseDefaultKey = ''
      }
    },
    'requestData.date': {
      handler () {
        this.scheduleFateDataUpdate()
      }
    },
    'requestData.time': {
      handler () {
        this.scheduleFateDataUpdate()
      }
    },
    'requestData.timezone': {
      handler () {
        this.scheduleFateDataUpdate()
        this.handleConfigFieldMutation('timezone')
      }
    },
    'requestData.address': {
      handler () {
        this.handleConfigFieldMutation('address')
      }
    },
    'requestData.longitudeDeg': {
      handler () {
        this.scheduleFateDataUpdate()
        this.handleConfigFieldMutation('longitude-deg')
      }
    },
    'requestData.longitudeMin': {
      handler () {
        this.scheduleFateDataUpdate()
        this.handleConfigFieldMutation('longitude-min')
      }
    },
    'requestData.longitudeSec': {
      handler () {
        this.scheduleFateDataUpdate()
        this.handleConfigFieldMutation('longitude-sec')
      }
    },
    'requestData.latitudeDeg': {
      handler () {
        this.scheduleFateDataUpdate()
        this.handleConfigFieldMutation('latitude-deg')
      }
    },
    'requestData.latitudeMin': {
      handler () {
        this.scheduleFateDataUpdate()
        this.handleConfigFieldMutation('latitude-min')
      }
    },
    'requestData.latitudeSec': {
      handler () {
        this.scheduleFateDataUpdate()
        this.handleConfigFieldMutation('latitude-sec')
      }
    },
    'requestData.zuoshan': {
      handler () {
        this.handleConfigFieldMutation('zuoshan')
      }
    },
    'requestData.hsys': {
      handler () {
        this.handleConfigFieldMutation('house-system')
      }
    },
    // 本命盘数据变化监听（仅当本命盘面板真正显示时才拉本命盘 generate）
    'requestData.natalDate': {
      handler () {
        this.handleConfigFieldMutation('natal-date')
      }
    },
    'requestData.natalTime': {
      handler () {
        this.handleConfigFieldMutation('natal-time')
      }
    },
    'requestData.natalAddress': {
      handler () {
        this.handleConfigFieldMutation('natal-address')
      }
    },
    'requestData.natalTimezone': {
      handler () {
        this.handleConfigFieldMutation('natal-timezone')
      }
    },
    'requestData.natalLongitudeDeg': {
      handler () {
        this.handleConfigFieldMutation('natal-longitude-deg')
      }
    },
    'requestData.natalLongitudeMin': {
      handler () {
        this.handleConfigFieldMutation('natal-longitude-min')
      }
    },
    'requestData.natalLongitudeSec': {
      handler () {
        this.handleConfigFieldMutation('natal-longitude-sec')
      }
    },
    'requestData.natalLatitudeDeg': {
      handler () {
        this.handleConfigFieldMutation('natal-latitude-deg')
      }
    },
    'requestData.natalLatitudeMin': {
      handler () {
        this.handleConfigFieldMutation('natal-latitude-min')
      }
    },
    'requestData.natalLatitudeSec': {
      handler () {
        this.handleConfigFieldMutation('natal-latitude-sec')
      }
    },
    stepValue () {
      this.handleConfigFieldMutation('step-interval-value')
    },
    stepUnit () {
      this.handleConfigFieldMutation('step-interval-unit')
    }
  },
  methods: {
    /**
       * 功能栏拖拽：按下手柄开始拖动
       *
       * 与「行星力量」悬浮表格同一套做法 —— 用 Pointer Events 统一鼠标 / 触摸 / 触控笔
       * （移动端浏览器在手指拖动过程中不派发 mousemove，纯鼠标事件在手机上拖不动），
       * 位移按「增量」计算（视口坐标差），避免页面滚动后坐标体系不一致导致跳变。
       *
       * 唯一区别：只允许从手柄起拖。功能栏里有按钮、数字输入框和下拉框，
       * 若整块可拖会在鼠标按下时就进入拖动、抢走这些控件的点击与文本选择
       * （「行星力量」表格没有交互控件，所以它可以整块拖）。
       *
       * @param {PointerEvent} event - 指针事件
       */
    handleFeatureToolbarPointerDown (event) {
      // 阻止冒泡，避免触发画布 / 页面上的其他点击处理
      event.stopPropagation()
      // 阻止 iOS 长按选中文本、弹出放大镜
      event.preventDefault()

      const toolbarEl = this.$refs.featureToolbar
      if (!toolbarEl) return

      // 首次拖动：把当前静态布局的位置换算成绝对坐标，切换定位方式时面板不会跳动。
      // offsetLeft / offsetTop 相对 offsetParent（.canvas-section，已设为 position: relative），
      // 与后面 absolute 的 left / top 参照同一坐标系。
      if (!this.featureToolbarPosition) {
        this.featureToolbarPosition = { x: toolbarEl.offsetLeft, y: toolbarEl.offsetTop }
      }

      this.isDraggingFeatureToolbar = true
      this.featureToolbarDragStart = {
        pointerX: event.clientX,
        pointerY: event.clientY,
        posX: this.featureToolbarPosition.x,
        posY: this.featureToolbarPosition.y
      }

      const handleEl = event.currentTarget
      this.featureToolbarDragTarget = handleEl

      // 捕获指针：指针移出手柄范围也能继续拖动，抬手或系统中断都能收到通知
      try {
        handleEl.setPointerCapture(event.pointerId)
      } catch (e) {
        // 个别环境不支持指针捕获，退化为普通监听即可
      }
      handleEl.addEventListener('pointermove', this.handleFeatureToolbarPointerMove)
      handleEl.addEventListener('pointerup', this.handleFeatureToolbarPointerUp)
      handleEl.addEventListener('pointercancel', this.handleFeatureToolbarPointerUp)
    },

    /**
       * 功能栏拖拽：按增量更新位置
       * @param {PointerEvent} event - 指针事件
       */
    handleFeatureToolbarPointerMove (event) {
      if (!this.isDraggingFeatureToolbar) return

      const start = this.featureToolbarDragStart
      // 与「行星力量」表格一致：不做边界钳制，允许放到画布内任意位置
      // （拖歪了刷新页面即可回到默认位置，因为位置不做持久化）
      this.featureToolbarPosition = {
        x: start.posX + (event.clientX - start.pointerX),
        y: start.posY + (event.clientY - start.pointerY)
      }
    },

    /**
       * 功能栏拖拽结束：抬手 / 指针取消（来电、手势被系统打断等）
       * @param {PointerEvent} event - 指针事件
       */
    handleFeatureToolbarPointerUp (event) {
      const handleEl = event.currentTarget || this.featureToolbarDragTarget
      if (handleEl) {
        handleEl.removeEventListener('pointermove', this.handleFeatureToolbarPointerMove)
        handleEl.removeEventListener('pointerup', this.handleFeatureToolbarPointerUp)
        handleEl.removeEventListener('pointercancel', this.handleFeatureToolbarPointerUp)
      }
      if (handleEl === this.featureToolbarDragTarget) {
        this.featureToolbarDragTarget = null
      }

      this.isDraggingFeatureToolbar = false
      this.featureToolbarDragStart = { pointerX: 0, pointerY: 0, posX: 0, posY: 0 }
    },

    normalizeTooltipInteractionMode (mode) {
      const normalizedMode = `${mode || ''}`.trim().toLowerCase()
      if (['hover', 'mouseover', '悬停'].includes(normalizedMode)) {
        return 'hover'
      }
      if (['click', '点击'].includes(normalizedMode)) {
        return 'click'
      }
      return 'click'
    },
    selectTooltipInteractionMode (mode) {
      this.tooltipInteractionMode = this.normalizeTooltipInteractionMode(mode)
      return this.tooltipInteractionMode
    },
    shouldFetchNatalAstrolabeData () {
      return this.showNatalChartOnCanvas &&
        ['ecliptic', 'horizon_ecliptic'].includes(this.requestData.astrolabeType) &&
        this.hasPermission('natal_chart') &&
        Boolean(this.requestData.natalDate)
    },
    bumpCanvasRenderRevision () {
      return issueRenderRevision(this.canvasRenderTracker)
    },
    handleCanvasRenderComplete (revision) {
      markRenderRevisionRendered(this.canvasRenderTracker, revision)
    },
    async waitForCanvasRender (revision) {
      await this.$nextTick()
      await waitForRenderRevision(this.canvasRenderTracker, revision)
    },
    async handleNatalPanelVisibilityChange (visible) {
      this.showNatalChartOnCanvas = Boolean(visible)
      if (!this.showNatalChartOnCanvas) {
        this.natalAstrolabeData = null
        this.bumpCanvasRenderRevision()
        return
      }
      if (this.astrolabeData && this.requestData.natalDate) {
        await this.generateAstrolabe()
      }
    },
    initializePermissionMode () {
      // TASK-015 起，主界面默认切到 api-controlled，统一消费后端 bootstrap 返回的正式权限结果。
      this.currentPermissionMode = PermissionService.setPermissionMode(
        PermissionService.PERMISSION_MODE_API_CONTROLLED
      )
    },
    syncPermissionModeView () {
      this.currentPermissionMode = PermissionService.getPermissionMode()
    },
    // 功能按钮点击处理
    getFeatureControlState (feature) {
      if (feature.direction === -1 || feature.direction === 1) {
        return getNavigationControlState(feature, this.autoPlayDirection)
      }
      return {
        className: feature.className || 'featureList-row',
        type: feature.type || 'default',
        icon: feature.icon,
        label: feature.label,
        style: feature.style
      }
    },
    handleFeatureClick (feature) {
      // 执行对应的功能方法
      if (feature.method && typeof feature.method === 'function') {
        feature.method(feature)
      }
    },
    // 解析日期（支持公元前日期，格式：-YYYY/MM/DD 或 YYYY/MM/DD）
    parseDate (dateStr) {
      return astrolabeRequestPayload.parseDate(dateStr)
    },
    // 获取行星力量列表
    async getPlanetPowerList (cond) {
      if (!this.hasPermission('planet_power')) {
        this.planetPowerList = []
        return
      }
      try {
        const response = await api.getPlanetPowerList(cond)
        this.planetPowerList = response.map(item => ({
          star: item.planetName ? item.planetName.substring(0, 2) : '',
          innate: item.innatePower,
          acquired: item.acquiredPower,
          score: item.totalPower
        }))
      } catch (error) {
        console.error('Failed to fetch planet power list:', error)
      }
    },
    // 计算真太阳时和四柱信息
    async fetchFate () {
      try {
        const requestPayload = astrolabeRequestPayload.buildFateRequestPayload({
          requestData: this.requestData,
          selectedPlanets: this.selectedPlanets,
          selectedStars: starControl.withControlledStars(this.selectedStars),
          selectedPoints: this.selectedPoints
        })

        const response = await api.fateCalculate(requestPayload)
        console.log('真太阳时计算结果:', response)
        return response
      } catch (error) {
        console.error('计算真太阳时失败:', error)
        throw error
      }
    },
    // 主盘命理刷新的统一入口（防抖）：日期/时间/经纬度是逐字符输入的，
    // 一次输入会连续触发多次命理刷新，这里收敛为「停止输入 300ms 后」的最后一次请求。
    scheduleFateDataUpdate () {
      if (this.fateUpdateTimer) {
        clearTimeout(this.fateUpdateTimer)
      }
      this.fateUpdateTimer = setTimeout(() => {
        this.fateUpdateTimer = null
        this.updateFateData()
      }, FATE_UPDATE_DEBOUNCE_MS)
    },

    // 本命盘命理刷新的统一入口（防抖），口径与主盘一致
    scheduleNatalFateDataUpdate () {
      if (this.natalFateUpdateTimer) {
        clearTimeout(this.natalFateUpdateTimer)
      }
      this.natalFateUpdateTimer = setTimeout(() => {
        this.natalFateUpdateTimer = null
        this.updateNatalFateData()
      }, FATE_UPDATE_DEBOUNCE_MS)
    },

    // 命理/农历失败提示：一轮失败只提示一次（逐字符输入会连续触发多次请求），成功后重置
    notifyFateFailureOnce (flagKey, message) {
      if (this[flagKey]) {
        return
      }
      this[flagKey] = true
      if (this.$message) {
        this.$message.error(message)
      }
    },

    // 更新命理数据
    async updateFateData () {
      // 先占号再判断权限：即使本次不发请求，也要让在途的旧请求响应作废，
      // 否则旧响应仍可能把过期的农历/四柱写回界面。
      const requestSeq = ++this.fateRequestSeq

      // 真太阳时接口同样受 basic_astrolabe 约束：无权限时直接跳过，
      // 免得在首屏链路里再产生一次无意义的 403（未登录 / 无权限的提示分别由
      // 「userId 缺失提示」与 handleAstrolabePermissionDenied 负责，这里不重复弹窗）。
      if (!this.hasPermission('basic_astrolabe')) {
        return
      }
      try {
        const fateData = formatFateDisplayData(await this.fetchFate())
        if (requestSeq !== this.fateRequestSeq) {
          // 已经有更新的命理请求发出：本次响应是过期数据，必须丢弃。
          // 逐字符输入 1996/06/15 会依次发出 year=1、19、199、1996… 的请求，
          // 过期响应晚到会把最终结果覆盖成「己卯年」这类中间态农历。
          return
        }
        this.fateData = fateData
        this.fateFailureNotified = false
        // 接口返回的农历 = 「星雲鑑历」（真太阳时/北京时间 23:00 口径），写入只读字段；
        // 「农历」行是万年历口径，由前端本地计算（syncWannianliLunarDate），两者互不覆盖。
        if (fateData.lunarDate) {
          this.requestData.lunarDateXYJ = fateData.lunarDate
          this.runtimeState.lunarDateXYJ = fateData.lunarDate
        }
      } catch (error) {
        console.error('更新命理数据失败:', error)
        if (requestSeq !== this.fateRequestSeq) {
          return
        }
        // 农历是按「当前公历日期」算出来的，接口失败时绝不能保留上一次的结果：
        // 留着旧值会让用户在新日期上看到上一个日期的干支年（例如把 1996 显示成己卯年）。
        this.fateData = {}
        this.requestData.lunarDateXYJ = ''
        this.runtimeState.lunarDateXYJ = ''
        // 日期字段是逐字符输入的，失败可能连续触发；同一轮失败只提示一次，成功后重置
        this.notifyFateFailureOnce('fateFailureNotified', '农历/命理计算失败，请稍后重试')
      }
    },
    // 计算本命盘真太阳时和四柱信息
    async fetchNatalFate () {
      try {
        const requestPayload = astrolabeRequestPayload.buildFateRequestPayload({
          requestData: {
            ...this.requestData,
            date: this.requestData.natalDate,
            time: this.requestData.natalTime || '00:00:00',
            longitudeDeg: this.requestData.natalLongitudeDeg,
            longitudeMin: this.requestData.natalLongitudeMin,
            longitudeSec: this.requestData.natalLongitudeSec,
            latitudeDeg: this.requestData.natalLatitudeDeg,
            latitudeMin: this.requestData.natalLatitudeMin,
            latitudeSec: this.requestData.natalLatitudeSec
          },
          selectedPlanets: this.selectedPlanets,
          selectedStars: starControl.withControlledStars(this.selectedStars),
          selectedPoints: this.selectedPoints
        })

        const response = await api.fateCalculate(requestPayload)
        console.log('本命盘真太阳时计算结果:', response)
        return response
      } catch (error) {
        console.error('计算本命盘真太阳时失败:', error)
        throw error
      }
    },
    // 更新本命盘命理数据
    async updateNatalFateData () {
      // 与主盘同样先占号：本命盘日期也是逐字符输入，过期响应必须作废，
      // 否则会把上一个日期算出的农历留在输入框里。
      const requestSeq = ++this.natalFateRequestSeq
      if (!this.requestData.natalDate) {
        return
      }
      try {
        const natalFateData = formatFateDisplayData(await this.fetchNatalFate())
        if (requestSeq !== this.natalFateRequestSeq) {
          return
        }
        this.natalFateData = natalFateData
        this.natalFateFailureNotified = false
        // 本命盘同理：接口返回的农历写入「星雲鑑历」只读字段，
        // 「农历」行仍由前端按万年历口径本地计算，互不覆盖。
        if (natalFateData.lunarDate) {
          this.requestData.natalLunarDateXYJ = natalFateData.lunarDate
          this.runtimeState.natalLunarDateXYJ = natalFateData.lunarDate
        }
      } catch (error) {
        console.error('更新本命盘命理数据失败:', error)
        if (requestSeq !== this.natalFateRequestSeq) {
          return
        }
        // 口径与主盘保持一致：失败时清空，避免残留上一个日期的农历
        this.natalFateData = {}
        this.requestData.natalLunarDateXYJ = ''
        this.runtimeState.natalLunarDateXYJ = ''
        this.notifyFateFailureOnce('natalFateFailureNotified', '本命盘农历/命理计算失败，请稍后重试')
      }
    },
    /**
     * 万年历农历（前端本地独立计算，2026-10-13 新增）。
     *
     * 口径：日月重合时刻落在**北京时间 24:00 之前**即算当天初一 —— 与后端「星雲鑑历」
     * （真太阳时/北京时间 23:00 分界）刻意区分，两者在「朔落在 23:00–24:00」时可能差一天。
     *
     * 边界：纯本地函数、不发请求、不写回 requestData.date、不进任何请求 payload，
     * 因此对星盘与四柱计算零影响；用户在「农历」输入框里的手改，只会在日期变化时才被重算覆盖。
     */
    syncWannianliLunarDate () {
      const basicLunar = wannianliLunar.formatWannianliLunar(this.requestData.date)
      this.requestData.lunarDate = basicLunar
      this.runtimeState.lunarDate = basicLunar

      const natalLunar = wannianliLunar.formatWannianliLunar(this.requestData.natalDate)
      this.requestData.natalLunarDate = natalLunar
      this.runtimeState.natalLunarDate = natalLunar
    },
    // 处理星盘类型变更
    handleAstrolabeTypeChange (type) {
      this.requestData.astrolabeType = type
      this.runtimeState.astrolabeType = type
      if (type === 'horizon' || type === 'equatorial') {
        this.showScale = true
        if (type === 'horizon') { this.showFixRing = true } else { this.showFixRing = false }
      } else {
        this.showScale = false
        this.showFixRing = false
      }
      this.generateAstrolabe()
    },
    // 获取恒星列表
    async fetchStarList () {
      if (!this.hasPermission('full_stars')) {
        this.starList = []
        return
      }
      try {
        const response = await api.getStarList()
        this.starList = response
      } catch (error) {
        console.error('Failed to fetch star list:', error)
      }
    },
    // 获取逻辑点列表
    async fetchLogicPointList () {
      if (!this.hasPermission('logic_points')) {
        this.logicPointList = []
        return
      }
      try {
        // 逻辑点 UI 兼容转换（过滤 46、补前端 dummy 游弋点）
        // 当前统一下沉到 AstrolabeCanvas.buildFrontendLogicPointList()，
        // 这里仅保留原始后端返回，避免父子两层重复做同一套兼容处理。
        const response = await api.getLogicPointList()
        this.logicPointList = Array.isArray(response) ? response : []
      } catch (error) {
        console.error('Failed to fetch logic point list:', error)
      }
    },
    // 获取行星列表
    async fetchPlanetList () {
      try {
        const response = await api.getPlanetList()
        this.planetList = response
      } catch (error) {
        console.error('Failed to fetch planet list:', error)
      }
    },
    // 更新逻辑点列表（对话框确定后会刷新星盘）
    updateLogicPoints (points) {
      this.selectedPoints = Array.from(new Set((Array.isArray(points) ? points : [])
        .map(point => Number(point))
        .filter(point => Number.isFinite(point))))
      this.handleConfigFieldMutation('logic-points')
      this.generateAstrolabe()
    },
    // 域名参数 ?userId=xxx 与全局登录态都取不到 userId 时统一走这里：提示用户先登录账号。
    // 解析口径集中在 services/userContext.getCurrentUserId（全局登录态 localStorage.user.id →
    // /onlineChart?userId=xxx），此处只负责提示；
    // 历史遗留的 astrolabe.userId 缓存已废弃，不再作为取值来源。
    notifyLoginRequired () {
      console.warn('[AstrolabeView] 未获取到 userId，星盘初始化已暂停，请先登录账号再使用。')
      if (this.$message) {
        this.$message.error('请先登录账号再使用')
      }
    },

    /**
     * 无 basic_astrolabe 权限时的统一处理：提示用户 + 把画布切到空态。
     *
     * 调用场景：
     *   1. 首屏 bootstrap 后发现没有该权限（不再发起任何星盘相关请求）；
     *   2. 生成接口返回 403（例如权限在会话中途被回收）；
     *   3. 其它会触发重新生成的入口（改行星/恒星/逻辑点、前进后退等）——
     *      它们最终都走 generateAstrolabe，由那里的守卫统一收敛，不会重复请求。
     */
    handleAstrolabePermissionDenied () {
      // 清空数据 + 触发一次渲染：AstrolabeCanvas 在数据为空时会清掉画布，
      // 保证画面是干净的空白，而不是残留旧盘或只剩一个白色底圆。
      this.astrolabeData = {}
      this.natalAstrolabeData = null
      this.planetPowerList = []
      this.bumpCanvasRenderRevision()

      // 会员租期已过的账号：追加「租期已过」续费引导弹窗
      // （放在去重标记之前，保证首屏 bootstrap 与生成接口 403 两条路径都能触发；
      //   弹窗自身用 renewPromptShown 保证一次会话只自动弹一次）
      this.maybeShowRenewPrompt()

      if (this.astrolabePermissionNotified) {
        return
      }
      this.astrolabePermissionNotified = true
      console.warn('[AstrolabeView] 当前账号没有 basic_astrolabe 权限，已停止星盘生成请求。')
      if (this.$message) {
        this.$message.error('当前账号暂无星盘使用权限，请联系客服开通后重试')
      }
    },

    // 从登录态读取会员状态（vip + 到期时间 express_time），
    // 供「租期已过 / 账号已禁用」判定与弹窗展示使用
    refreshMembershipState () {
      const user = userContext.readStoredTianxingUser()
      const expiry = user && user.express_time
      const vip = user && user.vip
      this.membershipExpiry = expiry ? String(expiry).trim() : ''
      this.membershipVip = vip === undefined || vip === null ? '' : String(vip).trim()
      return this.membershipExpiry
    },

    /**
     * 「会员租期已过」续费引导弹窗
     *
     * 触发条件（四者同时满足）：
     *   1. 当前账号没有星盘使用权限（红字提示已出现）；
     *   2. 登录态里的 vip 不是 3（账号未被禁用）；
     *   3. 登录态里有会员有效期 express_time；
     *   4. 该有效期已过期。
     * 从未开通过会员（express_time 为空）的账号不弹，只显示原有红字提示。
     */
    maybeShowRenewPrompt () {
      if (this.renewPromptShown) return
      if (this.hasPermission('basic_astrolabe')) return
      // 判定前刷新登录态里的会员状态（computed 基于这两个 data 字段，避免读到旧值）
      this.refreshMembershipState()
      // vip=3 已禁用：空态文案改为「当前会员状态被禁用，请联系客服」，
      // 不再弹 vip=2 的到期续费引导（对已禁用账号续费没有意义）
      if (this.isMembershipDisabled) return
      if (!this.isMembershipExpired) return

      this.renewPromptShown = true
      // 等空态红字渲染完成后再弹，避免与首屏其它提示挤在一起
      this.$nextTick(() => {
        this.renewDialogVisible = true
      })
    },
    // 红字里的「重新支付年租」：用户手动再唤起续费提示弹窗
    openRenewDialog () {
      this.renewDialogVisible = true
    },
    // 续费弹窗「支付年租」：关掉提示，打开与首页共用的会员购买弹窗
    handleRenewPay () {
      this.renewDialogVisible = false
      this.vipPurchaseVisible = true
    },
    /**
     * 按钮栏「开通功能」：未取到 userId 时先提示登录，避免打开弹窗后下单必然失败。
     * 权限清单、价格、二维码、轮询与开通后的登录态写回全部由弹窗内部完成。
     */
    handleOpenFeaturePurchase () {
      if (!this.currentUserId) {
        this.notifyLoginRequired()
        return
      }
      // 手动点「开通功能」：不预选任何一项
      this.featurePurchaseDefaultKey = ''
      this.featurePurchaseVisible = true
    },
    /**
     * 配置弹窗入口无权限（2026-10-11）：画布侧点击「恒星配置 / 行星配置 / 逻辑点」时，
     * 若没开通对应的管控权益（恒星管控 star_control / 行星管控 planet_control /
     * 逻辑点管控 logic_point_control），画布不开配置弹窗，改为把 key 抛上来。
     *
     * 这里走**两段式**，不直接弹付款界面：
     *   1) 先弹「无权限」确认框，告知需要开通哪一项；
     *   2) 用户点「确认开通」→ 才打开「开通功能」弹窗并定位高亮该项，引导扫码付款；
     *      用户点「取消」→ 只关掉提示框，不做任何跳转，也不打开付款界面。
     *
     * 付费成功后由 handleFeaturePurchasePaid 刷新登录态与按钮栏，用户可再次点击进入配置。
     *
     * @param {string} key - 权益 key（画布传来的 star_control / planet_control / logic_point_control）
     */
    async handleConfigGatePurchase (key) {
      if (!this.currentUserId) {
        this.notifyLoginRequired()
        return
      }
      const item = purchaseCatalog.findCatalogItem(key)
      const name = (item && item.name) || '该功能'
      // Element UI 的 confirm：点「确认开通」resolve('confirm')，点「取消」/关闭 reject('cancel')。
      // 这里统一把非确认结果 catch 成 false，只认「确认」这一种结果。
      const confirmed = await MessageBox.confirm(
        `该功能需先开通「${name}」，确认前往开通？`,
        '暂无使用权限',
        {
          confirmButtonText: '确认开通',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(() => false)
      // 取消 / 关闭提示框：什么都不做（不打开付款界面，也不产生任何跳转）
      if (!confirmed) {
        return
      }
      this.featurePurchaseDefaultKey = key
      this.featurePurchaseVisible = true
    },
    /**
     * 按钮栏「相位搜索」：入口判权。
     *
     * - 未登录（页面无 userId）：与「开通功能」口径一致，先提示登录；
     * - 已登录但无「和谐相位搜索」权益（users.hexie 到期时间）：提示后打开「开通功能」弹窗，
     *   并把「和谐相位搜索」项定位高亮，用户扫码支付后由 handleFeaturePurchasePaid 刷新权限；
     * - 有权益：打开相位搜索弹窗。
     *
     * 注意：星盘 /api/planet-longitudes、/api/eclipse/* 均为免鉴权接口，这里是**前端门禁**，
     * 直接调用接口仍可绕过；服务端强管控另行立项。
     */
    handleOpenPhaseSearch () {
      if (!this.currentUserId) {
        this.notifyLoginRequired()
        return
      }
      if (!this.hasPermission('harmonious_phase_search')) {
        if (this.$message) {
          this.$message.warning('该功能需先开通「和谐相位搜索」，请在下方选择并扫码支付')
        }
        this.featurePurchaseDefaultKey = 'harmonious_phase_search'
        this.featurePurchaseVisible = true
        return
      }
      this.phaseSearchVisible = true
    },
    /**
     * 权限开通成功：弹窗已把后端返回的最新 user 写回 localStorage，
     * 这里重新拉一次 bootstrap，让 PermissionService、按钮栏与画布同步生效；
     * 若刷新后目标权限仍未生效（例如星盘端权限计算延迟），回落整页刷新兜底。
     *
     * 0 元项（点报警 / 面报警等，payload.freeClaim）走另一条分支：这两项的效果由画布
     * 直接读登录态里的 pointAlarm / areaAlarm 判定，星盘端 bootstrap 并不下发对应的权限键，
     * 沿用上面的 hasPermission 校验会把「已开通」误判成「未生效」而每次整页刷新。
     * 因此这里只让画布就地重新判定一次报警权益。
     */
    async handleFeaturePurchasePaid (payload) {
      const expectedKey = payload && payload.item ? payload.item.key : ''
      // 支付/开通成功后先刷新全局登录态：用 id + auth_code 拉一次后端权威用户信息
      // 并写回 localStorage.user（写入即广播），保证"开通即全局生效"，不依赖整页刷新
      await this.refreshStoredTianxingUser()
      if (payload && payload.freeClaim) {
        this.refreshMembershipState()
        this.syncAstrolabeAlarmState()
        return
      }
      try {
        await this.bootstrapUserSession()
        if (typeof this.refreshMembershipState === 'function') {
          this.refreshMembershipState()
        }
        if (expectedKey && !this.hasPermission(expectedKey)) {
          console.warn('[AstrolabeView] 开通后权限未即时生效，回退整页刷新:', expectedKey)
          window.location.reload()
        }
      } catch (error) {
        console.error('[AstrolabeView] 开通成功后的权限刷新失败，回退整页刷新:', error)
        window.location.reload()
      }
    },
    /**
     * 刷新全局登录态（2026-10-11）：用登录态里的 id + auth_code 请求后端权威接口
     * `GET /yljx/public/login?id=xxx&auth_code=xxx`，取回最新用户信息后写回
     * localStorage.user 并广播，订阅回调会就地刷新本页权限/会员/报警权益。
     * 失败静默（不打断页面），保证"支付开通后无需整页刷新即可生效"。
     */
    async refreshStoredTianxingUser () {
      try {
        await refreshUser.refreshTianxingUser()
      } catch (error) {
        console.warn('[AstrolabeView] 刷新用户信息失败，保留本地登录态：', error)
      }
    },
    /**
     * 窗口重新聚焦 / 页面回到前台时刷新用户信息。
     * 典型场景：电脑上扫码付款后回到本页（或手机付款后切回电脑窗口）。
     * 20 秒内不重复请求，避免焦点抖动频繁打接口。
     */
    handleWindowFocusRefresh () {
      const now = Date.now()
      if (now - (this.lastUserRefreshAt || 0) < 20000) {
        return
      }
      this.lastUserRefreshAt = now
      this.refreshStoredTianxingUser()
    },
    /** 页面重新可见（切回标签页/从后台返回）时同样刷新，口径与聚焦一致 */
    handleVisibilityChangeRefresh () {
      if (typeof document === 'undefined' || document.visibilityState !== 'visible') {
        return
      }
      this.handleWindowFocusRefresh()
    },
    /**
     * 全局登录态变更（localStorage.user 被写入后广播）时的就地刷新：
     * 重读会员到期/等级、重判画布报警权益，并重新拉一次 bootstrap 权限，
     * 使「支付开通」在星盘页立即生效，不再依赖整页刷新。
     */
    async handleStoredTianxingUserChanged (user) {
      this.refreshMembershipState()
      this.syncAstrolabeAlarmState()
      try {
        await this.bootstrapUserSession()
      } catch (error) {
        // bootstrap 失败时保留页面已有权限（不额外弹窗打断用户），仅记录日志
        console.warn('[AstrolabeView] 登录态变更后刷新权限失败，保留现有权限：', error)
      }
    },
    /**
     * 让画布就地重新判定一次报警权益（点报警 / 面报警），用于 0 元项开通后立即生效。
     *
     * 画布侧读的是登录态（localStorage.user）里的 pointAlarm / areaAlarm，开通后无需换盘重绘。
     * 组件尚未挂载 / 老版本没有该方法时静默跳过，不阻断开通主流程。
     */
    syncAstrolabeAlarmState () {
      const canvas = this.$refs.astrolabeCanvas
      if (!canvas || typeof canvas.syncAlarmEntitlement !== 'function') {
        return
      }
      canvas.syncAlarmEntitlement()
    },
    /**
     * 红字里的「支付年租」（vip=1 且没有有效会员日期时的入口）
     *
     * 星盘页不再自己承接这档购买，而是返回主页并把支付诉求交给主页：
     * 主页已有年费支付弹窗（VipPurchaseDialog），这里只用 ?pay=annual 标记唤起，
     * 套餐价格、微信 H5 / 扫码支付、支付后写回登录态等行为全部复用同一套流程。
     */
    goHomeAndOpenVipPurchase () {
      this.$router.push({ path: '/tianxing/home', query: { pay: 'annual' } })
    },
    async bootstrapUserSession () {
      const resolvedUserId = userContext.getCurrentUserId()
      if (!resolvedUserId) {
        const error = new Error('Missing X-User-Id context before bootstrap request')
        console.error('用户 bootstrap 失败，当前页面没有可用 userId，上游必须显式传入 userId。', error)
        this.notifyLoginRequired()
        throw error
      }
      try {
        const bootstrap = await api.bootstrapUserSession()
        if (bootstrap && Array.isArray(bootstrap.permissions)) {
          // TASK-015 起统一使用后端 bootstrap 返回的正式权限结果。
          PermissionService.setPermissions(bootstrap.permissions)
          this.resolvedPermissions = [...PermissionService.getPermissions()]
          console.log('[AstrolabeView] bootstrap permissions applied', {
            userId: bootstrap.userId,
            bootstrapPermissions: bootstrap.permissions,
            servicePermissions: PermissionService.getPermissions(),
            permissionMode: PermissionService.getPermissionMode()
          })
          this.syncPermissionModeView()
        }
        if (bootstrap && bootstrap.userId) {
          this.currentUserId = userContext.setCurrentUserId(bootstrap.userId)
        }
        if (bootstrap && bootstrap.config) {
          this.applyLoadedConfig(bootstrap.config)
          this.configLoaded = Boolean(bootstrap.configExists)
        }
      } catch (error) {
        console.error('用户 bootstrap 失败，继续以本地默认状态启动:', error)
      }
      // 2026-10-18：地址与经度等字段同口径 —— bootstrap/load 回灌后直接渲染，不再清空。
      // 原先这里有一段 finally：每次进页面都把 requestData.address / natalAddress 置空。
      // 它会在 applyLoadedConfig 之后立刻抹掉刚读回来的地址（经度不受影响），
      // 并且后续任何一次配置变更自动保存都会把空地址回写，导致「保存好的地址永远读不回来」。
    },
    syncConfigStateFromView () {
      this.configState = astrolabeRequestPayload.extractConfigStateFromViewState({
        requestData: this.requestData,
        selectedPlanets: this.selectedPlanets,
        selectedStars: this.selectedStars,
        selectedPoints: this.selectedPoints,
        selectedMajorPhases: this.selectedMajorPhases,
        selectedMinorPhases: this.selectedMinorPhases,
        selectedMidpoints: this.selectedMidpoints,
        stepValue: this.stepValue,
        stepUnit: this.stepUnit
      })
    },
    syncRuntimeStateFromView () {
      this.runtimeState = astrolabeRequestPayload.extractRuntimeStateFromRequestData({
        requestData: this.requestData
      })
    },
    markConfigDomainChanged (reason) {
      this.syncConfigStateFromView()
      this.configDirty = true
      this.lastConfigChangeReason = reason
    },
    handleConfigFieldMutation (reason) {
      if (this.suspendConfigWatch) {
        return
      }
      this.lastAutoSaveFailureFingerprint = ''
      this.markConfigDomainChanged(reason)
      this.scheduleConfigSave(reason)
    },
    scheduleConfigSave (reason = 'config-change') {
      if (this.suspendConfigWatch) {
        return
      }
      clearTimeout(this.autoSaveTimer)
      this.pendingAutoSaveReason = reason
      this.autoSaveTimer = setTimeout(() => {
        this.autoSaveTimer = null
        if (!this.configDirty) {
          return
        }
        this.requestSaveConfigFromDialog({ force: true, source: `auto:${reason}` })
      }, 600)
    },
    buildCurrentSaveConfigPayload () {
      this.syncConfigStateFromView()
      return astrolabeRequestPayload.buildSaveConfigPayload({
        configState: this.configState
      })
    },
    normalizeConfigForCompare (config) {
      return astrolabeRequestPayload.normalizePersistedConfig(config)
    },
    buildConfigFingerprint (config) {
      return JSON.stringify(this.normalizeConfigForCompare(config))
    },
    findConfigMismatchKeys (expectedConfig, actualConfig) {
      const normalizedExpected = this.normalizeConfigForCompare(expectedConfig)
      const normalizedActual = this.normalizeConfigForCompare(actualConfig)
      const keys = Array.from(new Set([
        ...Object.keys(normalizedExpected || {}),
        ...Object.keys(normalizedActual || {})
      ]))
      return keys.filter(key => JSON.stringify(normalizedExpected[key]) !== JSON.stringify(normalizedActual[key]))
    },
    isConfigPersisted (expectedConfig, actualConfig) {
      if (!actualConfig) {
        return false
      }
      return this.findConfigMismatchKeys(expectedConfig, actualConfig).length === 0
    },
    applyLoadedConfig (config) {
      this.suspendConfigWatch = true
      try {
        this.configState = astrolabeRequestPayload.mergeLoadedConfigIntoConfigState({
          configState: this.configState,
          config
        })
        this.selectedPlanets = this.configState.selectedPlanets || this.selectedPlanets
        // 读取已存配置后同样并入受管控恒星（老用户的配置里通常不含这 17 个）
        this.selectedStars = starControl.withControlledStars(this.configState.selectedStars || this.selectedStars)
        this.selectedPoints = Array.from(new Set((this.configState.selectedPoints || this.selectedPoints)
          .map(pointId => {
            const numericPointId = Number(pointId)
            return numericPointId === LEGACY_NEBULA_LOGIC_POINT_ID
              ? FRONTEND_DUMMY_YOUYI_POINT_ID
              : numericPointId
          })
          .filter(pointId => Number.isFinite(pointId))))
        this.selectedMajorPhases = this.configState.selectedMajorPhases || this.selectedMajorPhases
        this.selectedMinorPhases = this.configState.selectedMinorPhases || this.selectedMinorPhases
        this.selectedMidpoints = this.configState.selectedMidpoints || this.selectedMidpoints
        this.stepValue = this.configState.stepIntervalValue || this.stepValue
        this.stepUnit = this.configState.stepIntervalUnit || this.stepUnit
        this.requestData = astrolabeRequestPayload.mergeLoadedConfigIntoRequestData({
          requestData: this.requestData,
          config
        })
        this.runtimeState = astrolabeRequestPayload.extractRuntimeStateFromRequestData({
          requestData: this.requestData
        })
        if (this.requestData.toleranceMatrix || this.requestData.phaseToleranceRows) {
          this.syncPhaseToleranceState({
            toleranceMatrix: this.requestData.toleranceMatrix,
            phaseToleranceRows: this.requestData.phaseToleranceRows
          })
        }
        this.configDirty = false
        this.lastConfigChangeReason = ''
      } finally {
        this.$nextTick(() => {
          this.suspendConfigWatch = false
        })
      }
    },
    // 更新信息面板的方法
    updateInfo (formData) {
      // 只存储原始数据，不进行格式化
      this.requestData = {
        ...this.requestData,
        ...formData
      }
      const statePatch = astrolabeRequestPayload.applyFormDataPatchToPageState({
        configState: this.configState,
        runtimeState: this.runtimeState,
        formData
      })
      this.configState = statePatch.configState
      this.runtimeState = statePatch.runtimeState
      if (statePatch.configChanged) {
        this.configDirty = true
        this.lastConfigChangeReason = 'form-update'
        this.scheduleConfigSave('form-update')
      }
    },
    syncPhaseToleranceState (statePatch = {}) {
      const resolvedState = phaseToleranceProtocol.resolvePhaseToleranceState({
        toleranceMatrix: statePatch.toleranceMatrix !== undefined ? statePatch.toleranceMatrix : this.requestData.toleranceMatrix,
        phaseToleranceRows: statePatch.phaseToleranceRows !== undefined ? statePatch.phaseToleranceRows : this.requestData.phaseToleranceRows
      })
      this.requestData.toleranceMatrix = resolvedState.toleranceMatrix
      this.requestData.phaseToleranceRows = resolvedState.phaseToleranceRows
      this.syncConfigStateFromView()
    },
    getHouseSystemName (code) {
      const systems = {
        A: '等宫制 (Equal)',
        B: '阿尔卡比特制 (Alcabitius)',
        C: '坎帕纳斯制 (Campanus)',
        G: '36高奎兰分区 (36 Gauquelin sectors)',
        H: '地平/方位宫位制 (horizon/azimut)',
        K: '科赫制 (Koch)',
        M: '莫里纳斯制 (Morinus)',
        O: '波菲里制 (Porphyry)',
        P: '普拉西德制 (Placidus)',
        R: '瑞吉欧蒙塔纳制 (Regiomontanus)',
        T: '波利奇/佩吉制 (topocentric)',
        U: '克鲁辛斯基-皮萨-戈尔泽制 (Krusinski-Pisa-Goelzer)',
        V: '等宫维赫洛制 (equal Vehlow)',
        W: '等宫全星座制 (equal, whole sign)',
        X: '轴旋转系统/子午线宫位制 (axial rotation system/Meridian houses)',
        Y: 'APC宫位制 (APC houses)',
        E: '等宫制 (Equal)' // 注意：表单中有两个'E'选项，但显示相同
      }
      return systems[code] || `未知分宫制 (${code})`
    },

    formatTimezoneLabel (timezone) {
      if (timezone === undefined || timezone === null || timezone === '') {
        return ''
      }
      const numericTimezone = Number(timezone)
      if (Number.isNaN(numericTimezone)) {
        return `${timezone}`
      }
      const prefix = numericTimezone >= 0 ? '+' : ''
      return `UTC${prefix}${numericTimezone}`
    },

    // 星盘类型转换方法
    getAstrolabeTypeName (type) {
      const typeMap = {
        ecliptic: '黄道盘',
        horizon_ecliptic: '地平黄道盘',
        equatorial: '赤道盘',
        horizon: '地平盘'
      }
      return typeMap[type] || `未知星盘类型 (${type})`
    },

    // 日期时间变化处理
    changeDate (feature, icon) {
      const [direction] = feature.option
      this.adjustDateTime(parseInt(direction) * this.stepValue, this.stepUnit)
    },

    // 调整日期时间的通用方法
    async adjustDateTime (value, unit) {
      const adjustedDateTime = adjustAstrolabeDateTime({
        date: this.requestData.date,
        time: this.requestData.time,
        amount: value,
        unit
      })

      this.requestData.date = adjustedDateTime.date
      this.requestData.time = adjustedDateTime.time
      this.syncRuntimeStateFromView()

      // 自动生成星盘
      await this.generateAstrolabe()
    },
    async stop () {
      clearTimeout(this.timer)
      this.timer = null
      if (this.autoPlayWaitResolver) {
        const resolveWait = this.autoPlayWaitResolver
        this.autoPlayWaitResolver = null
        resolveWait(false)
      }
      this.autoPlayLoopSeq += 1
      this.autoPlayDirection = 0
      const runPromise = this.autoPlayRunPromise
      if (runPromise) {
        await runPromise
      }
    },
    // 前进和后退共用同一条串行自动播放链，完成请求与渲染后才等待下一步。
    async toggleAutoPlay (feature = {}) {
      const requestedDirection = Number(feature.direction || (feature.option && feature.option[0]) || 1)
      const nextDirection = resolvePlaybackDirection(this.autoPlayDirection, requestedDirection)
      if (this.isAutoPlaying) {
        await this.stop()
      }
      if (nextDirection === 0) {
        console.log('停止自动播放')
        return
      }

      this.autoPlayDirection = nextDirection
      const loopSeq = ++this.autoPlayLoopSeq
      const runPromise = this.runAutoPlayLoop(loopSeq, nextDirection)
      this.autoPlayRunPromise = runPromise
      runPromise.then(() => {
        if (this.autoPlayRunPromise === runPromise) {
          this.autoPlayRunPromise = null
        }
      }, () => {
        if (this.autoPlayRunPromise === runPromise) {
          this.autoPlayRunPromise = null
        }
      })
      console.log(nextDirection < 0 ? '开始自动后退' : '开始自动前进')
    },
    async waitForNextAutoPlayTick (loopSeq, direction) {
      await new Promise(resolve => {
        const finishWait = result => {
          if (this.autoPlayWaitResolver !== finishWait) return
          this.autoPlayWaitResolver = null
          this.timer = null
          resolve(result)
        }
        this.autoPlayWaitResolver = finishWait
        this.timer = setTimeout(() => {
          finishWait(true)
        }, 1000)
      })
      return this.autoPlayDirection === direction && loopSeq === this.autoPlayLoopSeq
    },
    async runAutoPlayLoop (loopSeq, direction) {
      await runSerialPlayback({
        direction,
        shouldContinue: currentDirection => this.autoPlayDirection === currentDirection && loopSeq === this.autoPlayLoopSeq,
        step: currentDirection => this.autoStep(currentDirection),
        wait: () => this.waitForNextAutoPlayTick(loopSeq, direction)
      })
    },
    // 自动步进
    async autoStep (direction) {
      await this.adjustDateTime(direction * this.stepValue, this.stepUnit)
      console.log(`自动步进 ${direction * this.stepValue} ${this.stepUnit}`)
    },

    // 更新行星选择（对话框确定后会刷新星盘）
    updatePlanets (planetIds) {
      this.selectedPlanets = planetIds
      this.handleConfigFieldMutation('selected-planets')
      this.generateAstrolabe()
    },

    updateStars (starIds) {
      // 受管控恒星恒参与请求：这里做并集，用户在弹窗里怎么点都无法把它们去掉
      this.selectedStars = starControl.withControlledStars(starIds)
      this.handleConfigFieldMutation('selected-stars')
      this.generateAstrolabe()
    },

    updateToleranceMatrix (matrix) {
      this.syncPhaseToleranceState({ toleranceMatrix: matrix })
      this.handleConfigFieldMutation('tolerance-matrix')
    },
    updatePhaseToleranceRows (phaseToleranceRows) {
      this.syncPhaseToleranceState({ phaseToleranceRows })
      this.handleConfigFieldMutation('phase-tolerance-rows')
    },

    /**
     * 恒星容许度（逐颗）：弹窗提交的是数组 `[{id, tolerance}]`，
     * 持久化与下发星盘的口径统一为映射 `{ starNum: 度 }`。
     *
     * 只保留「非默认值（≠1°0'0"）」的项：未配置即默认 1°，与历史行为完全一致，
     * 也避免把 211 颗恒星全量写进用户配置与星盘请求。
     * 星盘服务按该映射逐颗覆盖 `BOStarInfo.tolerance`（恒星报警判定阈值）。
     */
    updateStarToleranceMatrix (starList) {
      this.$set(this.requestData, 'starToleranceMap', starTolerance.buildStarToleranceMap(starList))
      this.syncConfigStateFromView()
      this.handleConfigFieldMutation('star-tolerance-map')
    },
    // 更新相位选择
    updatePhases (phaseData) {
      this.selectedMajorPhases = phaseData.majorPhases
      this.selectedMinorPhases = phaseData.minorPhases
      this.phaseCellSelections = phaseData.cellSelections || []
      this.handleConfigFieldMutation('selected-phases')
      this.generateAstrolabe()
    },
    // 更新催贵公式选择
    updateMidpoints (midpointPairs) {
      if (!this.hasPermission('midpoint_formula')) {
        this.$message.warning('催贵公式为高级会员项目')
        return
      }
      this.selectedMidpoints = midpointPairs
      this.handleConfigFieldMutation('selected-midpoints')
      this.generateAstrolabe()
    },
    buildTooltipRemarkStorageKey (item) {
      return buildTooltipRemarkStorageKey(item)
    },
    updateTooltipRemark (updatedItem) {
      const storageKey = this.buildTooltipRemarkStorageKey(updatedItem)
      if (!storageKey) {
        return
      }
      const nextRemarkMap = {
        ...(this.requestData.tooltipRemarkMap || {})
      }
      if (updatedItem.remark) {
        nextRemarkMap[storageKey] = updatedItem.remark
      } else {
        delete nextRemarkMap[storageKey]
      }
      this.$set(this.requestData, 'tooltipRemarkMap', nextRemarkMap)
      this.handleConfigFieldMutation('tooltip-remark')
    },
    // 权限检查辅助方法
    hasPermission (key) {
      return PermissionService.hasPermission(key)
    },
    async requestSaveConfigFromDialog (options = {}) {
      const force = Boolean(options.force)
      if (!force && !this.configDirty) {
        return
      }
      clearTimeout(this.autoSaveTimer)
      this.autoSaveTimer = null
      const source = options.source || this.lastConfigChangeReason || 'config-change'
      const isAutoSave = String(source).startsWith('auto:')
      const configData = this.buildCurrentSaveConfigPayload()
      const configFingerprint = this.buildConfigFingerprint(configData)
      if (shouldSkipRepeatedAutoSave({
        isAutoSave,
        configFingerprint,
        lastFailureFingerprint: this.lastAutoSaveFailureFingerprint
      })) {
        console.warn('检测到同一份失败配置再次自动保存，已跳过重复请求', { source })
        return
      }
      if (this.configSaveInFlight) {
        this.pendingAutoSaveReason = source
        return
      }
      this.configSaveInFlight = true
      try {
        await this.saveConfig(configData, { source, auto: isAutoSave, fingerprint: configFingerprint })
      } finally {
        this.configSaveInFlight = false
        if (this.pendingAutoSaveReason && this.configDirty) {
          const pendingReason = this.pendingAutoSaveReason
          this.pendingAutoSaveReason = ''
          this.scheduleConfigSave(pendingReason)
        }
      }
    },
    delay (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    async loadPersistedConfigWithRetry (expectedConfig, attempts = 4, delayMs = 250) {
      let lastLoadedConfig = null
      for (let attempt = 1; attempt <= attempts; attempt += 1) {
        lastLoadedConfig = await api.loadConfig()
        if (this.isConfigPersisted(expectedConfig, lastLoadedConfig)) {
          return lastLoadedConfig
        }
        if (attempt < attempts) {
          await this.delay(delayMs)
        }
      }
      return lastLoadedConfig
    },
    // 保存配置到后台
    async saveConfig (preparedConfig = null, options = {}) {
      const configData = preparedConfig || this.buildCurrentSaveConfigPayload()
      const configFingerprint = options.fingerprint || this.buildConfigFingerprint(configData)
      try {
        console.log('准备保存配置，请确认网络面板中出现 POST /api/user-config/current', configData)
        await api.saveConfig(configData)

        this.lastAutoSaveFailureFingerprint = ''

        console.log('准备执行强制回读，请确认网络面板中出现 POST /api/user-config/load')
        const reloadedConfig = await this.loadPersistedConfigWithRetry(configData)
        if (!this.isConfigPersisted(configData, reloadedConfig)) {
          const mismatchedKeys = this.findConfigMismatchKeys(configData, reloadedConfig)
          this.lastAutoSaveFailureFingerprint = resolveAutoSaveFailureFingerprint({
            isAutoSave: Boolean(options.auto),
            configFingerprint
          })
          this.configDirty = true
          this.lastConfigChangeReason = 'save-not-persisted'
          console.warn('配置提交后未从远端读取到一致数据', {
            mismatchedKeys,
            expected: this.normalizeConfigForCompare(configData),
            actual: this.normalizeConfigForCompare(reloadedConfig)
          })
          this.$message && this.$message.error('保存请求已发送，但远端未返回一致配置，请继续检查后端外部存储链路')
          return
        }

        this.applyLoadedConfig(reloadedConfig)
        this.configLoaded = true
        this.configDirty = false
        this.lastConfigChangeReason = ''
        console.log('配置保存成功，且远端回读校验通过')
        this.$message && this.$message.success('配置已保存并回读通过，请在 Network 中确认 POST /api/user-config/current 与 POST /api/user-config/load')
      } catch (error) {
        this.lastAutoSaveFailureFingerprint = resolveAutoSaveFailureFingerprint({
          isAutoSave: Boolean(options.auto),
          configFingerprint
        })
        console.error('保存配置失败:', error)
        if (options.auto) {
          console.warn('自动保存已记录失败指纹；在配置再次变更前，将跳过同一份失败载荷的重复提交', {
            source: options.source,
            fingerprint: configFingerprint
          })
        }
        this.$message && this.$message.error('保存配置失败，请检查 /api/user-config/current 与 /api/user-config/load 以及后端外部存储链路')
      }
    },
    // 从后台加载配置
    async loadConfig () {
      try {
        console.log('准备加载配置，请确认网络面板中出现 POST /api/user-config/load')
        const config = await api.loadConfig()
        if (config) {
          this.applyLoadedConfig(config)
          this.configLoaded = true
          console.log('配置加载成功')
          this.$message && this.$message.success('配置已加载，请确认 POST /api/user-config/load 返回的内容')
          return
        }
        this.$message && this.$message.warning('当前未从远端读取到配置，请继续检查后端外部存储是否已启用')
      } catch (error) {
        console.error('加载配置失败:', error)
        this.$message && this.$message.error('加载配置失败，请检查 /api/user-config/load 与后端外部存储开关')
      }
    },

    // 单次执行
    cloneChartData (chartData) {
      return chartData ? JSON.parse(JSON.stringify(chartData)) : null
    },
    resolveBundleChart (bundleResponse, chartId, role) {
      return astrolabeBundleResponse.resolveBundleChart(bundleResponse, chartId, role)
    },
    async generateAstrolabe () {
      // 无权限守卫：所有"需要出盘"的入口（首屏、改行星/恒星/逻辑点、前进后退、
      // 本命盘面板切换等）最终都会走到这里，统一在此拦截 ——
      // 既不向后端发请求，也不重试，避免无权限账号反复刷 403。
      if (!this.hasPermission('basic_astrolabe')) {
        this.handleAstrolabePermissionDenied()
        return
      }

      const generateRequestId = ++this.generateRequestSeq
      this.loading = true

      try {
        const bundleRequest = astrolabeRequestPayload.buildGenerateBundlePayload({
          requestData: this.requestData,
          selectedPlanets: this.selectedPlanets,
          selectedStars: starControl.withControlledStars(this.selectedStars),
          selectedPoints: this.selectedPoints,
          selectedMidpoints: this.selectedMidpoints,
          shouldFetchNatal: this.shouldFetchNatalAstrolabeData()
        })

        const bundleResponse = await api.generateAstrolabeBundle(bundleRequest.payload)

        if (generateRequestId !== this.generateRequestSeq) {
          return
        }

        const mainChart = this.resolveBundleChart(bundleResponse, 'main', 'main')
        if (!mainChart || !mainChart.data) {
          console.warn('[AstrolabeView] generate-bundle 未返回主盘数据')
          return
        }

        this.astrolabeData = mainChart.data
        if (bundleRequest.shouldFetchNatal) {
          if (bundleRequest.reuseNatalFromMain) {
            this.natalAstrolabeData = this.cloneChartData(mainChart.data)
          } else {
            const natalChart = this.resolveBundleChart(bundleResponse, 'natal', 'natal')
            if (!natalChart || !natalChart.data) {
              console.warn('[AstrolabeView] generate-bundle 未返回本命盘数据')
              return
            }
            this.natalAstrolabeData = natalChart.data
          }
        } else {
          this.natalAstrolabeData = null
        }

        const renderRevision = this.bumpCanvasRenderRevision()
        await this.waitForCanvasRender(renderRevision)
        this.getPlanetPowerList(bundleRequest.mainInput)
      } catch (error) {
        if (isAstrolabePermissionDenied(error)) {
          // 权限在会话中途被回收（后端返回 403）：给出提示并切到空态
          this.handleAstrolabePermissionDenied()
        } else {
          console.error('生成星盘失败:', error)
        }
      } finally {
        if (generateRequestId === this.generateRequestSeq) {
          this.loading = false
        }
      }
    },

    // 获取本命盘数据
    async fetchNatalAstrolabeData () {
      if (!this.shouldFetchNatalAstrolabeData()) {
        return null
      }

      try {
        // 本命盘固定使用：日、月、水、金、火、木、土、天、海、冥、计都(11)、Asc、Mc
        const natalSelectedPlanets = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 1000014, 1000015]
        const requestPayload = astrolabeRequestPayload.buildNatalGeneratePayload({
          requestData: this.requestData,
          natalSelectedPlanets
        })
        return await api.generateAstrolabe(requestPayload)
      } catch (error) {
        console.error('获取本命盘数据失败:', error)
        return null
      }
    },

    // 生成本命盘数据（用于黄道盘外圈）
    async generateNatalAstrolabe () {
      await this.generateAstrolabe()
    },

    // 保存图片功能
    async saveImage () {
      try {
        // 截取 canvas 容器（包含星盘画布和 InfoPanel）
        const target = document.getElementById('canvasAlarm')
        const viewRoot = document.getElementById('AstrolabeView')
        if (!target) {
          console.error('未找到截图目标元素 #canvasAlarm')
          return
        }

        const targetRect = target.getBoundingClientRect()
        const targetStyle = window.getComputedStyle(target)
        const viewStyle = viewRoot ? window.getComputedStyle(viewRoot) : null
        const backgroundImageValue = viewStyle ? viewStyle.backgroundImage : ''
        const backgroundImageMatch = backgroundImageValue && backgroundImageValue !== 'none'
          ? backgroundImageValue.match(/url\((['"]?)(.*?)\1\)/)
          : null
        const backgroundImageUrl = backgroundImageMatch && backgroundImageMatch[2]
          ? backgroundImageMatch[2]
          : ''

        const canvas = await html2canvas(target, createAstrolabeImageExportOptions((clonedDoc) => {
          const clonedTarget = clonedDoc.getElementById('canvasAlarm')
          if (!clonedTarget) {
            return
          }

          if (viewStyle) {
            clonedTarget.style.backgroundImage = viewStyle.backgroundImage
            clonedTarget.style.backgroundColor = viewStyle.backgroundColor
            clonedTarget.style.backgroundRepeat = viewStyle.backgroundRepeat
            clonedTarget.style.backgroundSize = viewStyle.backgroundSize
            clonedTarget.style.backgroundPosition = viewStyle.backgroundPosition
            clonedTarget.style.backgroundAttachment = 'scroll'
          }

          clonedTarget.style.position = 'relative'
          clonedTarget.style.borderRadius = targetStyle.borderRadius
          clonedTarget.style.overflow = 'hidden'
          clonedTarget.style.width = `${Math.ceil(targetRect.width)}px`
          clonedTarget.style.minHeight = `${Math.ceil(targetRect.height)}px`

          if (backgroundImageUrl) {
            const backgroundLayer = clonedDoc.createElement('img')
            backgroundLayer.src = backgroundImageUrl
            backgroundLayer.alt = '背景图'
            backgroundLayer.setAttribute('data-export-background', 'true')
            backgroundLayer.style.position = 'absolute'
            backgroundLayer.style.inset = '0'
            backgroundLayer.style.width = '100%'
            backgroundLayer.style.height = '100%'
            backgroundLayer.style.objectFit = 'cover'
            backgroundLayer.style.objectPosition = viewStyle ? viewStyle.backgroundPosition : 'center center'
            backgroundLayer.style.zIndex = '0'
            backgroundLayer.style.pointerEvents = 'none'
            clonedTarget.insertBefore(backgroundLayer, clonedTarget.firstChild)
          }

          Array.from(clonedTarget.children).forEach(node => {
            if (node.getAttribute && node.getAttribute('data-export-background') === 'true') {
              return
            }
            if (!node.style.position || node.style.position === 'static') {
              node.style.position = 'relative'
            }
            if (!node.style.zIndex) {
              node.style.zIndex = '1'
            }
          })

          clonedTarget.querySelectorAll('.config-panel, .draggable-score-table, .tooltip').forEach(node => {
            node.style.display = 'none'
          })
        }))

        // 生成默认文件名：姓名_日期_时间
        const name = this.requestData.name || '星盘'
        const dateStr = (this.requestData.date || '').replace(/\//g, '-')
        const timeStr = (this.requestData.time || '').replace(/:/g, '-')
        const defaultFileName = `${name}_${dateStr}_${timeStr}.png`

        // 优先使用 File System Access API（支持用户选择保存位置）
        if (window.showSaveFilePicker) {
          try {
            const handle = await window.showSaveFilePicker({
              suggestedName: defaultFileName,
              types: [{
                description: 'PNG 图片',
                accept: { 'image/png': ['.png'] }
              }]
            })
            const writable = await handle.createWritable()
            const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'))
            await writable.write(blob)
            await writable.close()
            console.log('图片保存成功')
            return
          } catch (err) {
            // 用户取消了保存对话框
            if (err.name === 'AbortError') return
            console.warn('File System Access API 失败，降级为下载:', err)
          }
        }

        // 降级方案：通过 <a> 标签下载
        const link = document.createElement('a')
        link.download = defaultFileName
        link.href = canvas.toDataURL('image/png')
        link.click()
      } catch (error) {
        console.error('保存图片失败:', error)
      }
    }
  },

  beforeDestroy () {
    // 退订登录态变更 + 移除焦点/前台刷新监听，避免销毁后回调仍在跑
    if (typeof this.unsubscribeTianxingUser === 'function') {
      this.unsubscribeTianxingUser()
      this.unsubscribeTianxingUser = null
    }
    if (typeof window !== 'undefined' && window.removeEventListener) {
      window.removeEventListener('focus', this.handleWindowFocusRefresh)
    }
    if (typeof document !== 'undefined' && document.removeEventListener) {
      document.removeEventListener('visibilitychange', this.handleVisibilityChangeRefresh)
    }
    if (typeof this.unwatchWannianliLunar === 'function') {
      this.unwatchWannianliLunar()
      this.unwatchWannianliLunar = null
    }
    // 组件销毁前清掉命理刷新防抖定时器，避免销毁后仍触发请求
    if (this.fateUpdateTimer) {
      clearTimeout(this.fateUpdateTimer)
      this.fateUpdateTimer = null
    }
    if (this.natalFateUpdateTimer) {
      clearTimeout(this.natalFateUpdateTimer)
      this.natalFateUpdateTimer = null
    }
    // 组件销毁前解绑功能栏拖拽监听，避免残留监听持有已销毁的实例
    if (this.featureToolbarDragTarget) {
      this.featureToolbarDragTarget.removeEventListener('pointermove', this.handleFeatureToolbarPointerMove)
      this.featureToolbarDragTarget.removeEventListener('pointerup', this.handleFeatureToolbarPointerUp)
      this.featureToolbarDragTarget.removeEventListener('pointercancel', this.handleFeatureToolbarPointerUp)
      this.featureToolbarDragTarget = null
    }
  }
}
</script>

<style scoped>
  /* 新增背景容器样式 */
  #AstrolabeView.background-container {
    /* 移动端：iOS Safari 不支持 background-attachment: fixed，横滑时背景会错位/不跟随，
       改为随内容滚动（scroll）后，左右滑动时背景与内容一致。 */
    background: url('~@/assets/bg.jpg') no-repeat center center;
    background-size: cover;
    position: relative;
    min-height: 100vh;
  }

  /* 添加半透明遮罩層 */
  #AstrolabeView.background-container::before {
    content: '';
    /* position: absolute; */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /* background: rgba(0, 0, 0, 0.1); */
    z-index: 0;
  }

  /* 确保内容在遮罩层上方 */
  #AstrolabeView > * {
    position: relative;
    z-index: 1;
  }

  /* 防御：Element 弹窗挂载点必须保持 fixed 全屏。
     上面的 `> *` 规则会命中挂在根节点下的弹窗（子组件根元素带父级 scopeId），
     把 .el-dialog__wrapper 的 position: fixed 改成 relative —— 弹窗会掉进文档流、
     被挤到页面最下方，且点击遮罩关闭也会失效。
     弹窗现已 append-to-body（不在本规则作用范围内），这里保留一条兜底规则。 */
  #AstrolabeView > .el-dialog__wrapper {
    position: fixed;
    z-index: 2000;
  }

  /* 手机查看策略（与 PC 保持一致）：整页按桌面宽度渲染，靠原生上下左右滑动 +
     双指缩放查看，而不是把布局重排到窄屏。
     - overflow 由 hidden 改回 visible：hidden 会把横向溢出的星盘直接裁掉，
       且根节点不是滚动容器，手机上既看不到也拖不动，这是「内容缺失」的根因。
     - min-width: max-content：窄屏时根节点被内容撑开，横向溢出转为页面级滚动，
       用户即可左右滑动。PC 上 width: 100% 仍大于 max-content，观感不变。
     - 移除 max-width: 100%：否则会把宽度重新压回视口宽，min-width 失去意义。 */
  #AstrolabeView {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: max-content;
    margin: 0 auto;
    overflow: visible;
  }

  /* 頁眉頁腳樣式調整 */
  header, footer {
    background: rgba(10, 15, 30, 0.85);
    color: #e0e0ff;
    padding: 10px 25px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
    text-align: center;
    position: relative;
  }

  header h1 {
    margin: 0;
    font-size: 28px;
    letter-spacing: 1px;
    text-shadow: 0 0 10px rgba(100, 150, 255, 0.7);
  }

  .subtitle {
    font-size: 16px;
    opacity: 0.85;
    margin-top: 5px;
    letter-spacing: 3px;
  }

  footer {
    font-size: 14px;
    letter-spacing: 1px;
    padding: 12px 25px;
    margin-top: auto;
  }

  /* 內容區域樣式調整 */
  .content {
    display: flex;
    flex-direction: row;
    padding: 15px;
    gap: 20px;
    flex: 1;
    /* 手机查看策略：给内容区一个能放下星盘（880+内边距 ≈ 904）+ 表单（≥360）
       的宽度下限，窄屏不再把两块挤压变形，超出的部分改为滑动查看。
       1280 不够：星盘区因 canvas 不可收缩而拿满 904，缺口全部落在表单区，
       表单被压到 ~246px 后「地址 + 地图按钮」这一行就会被挤换行。
       1330 同时保证 1366 宽的笔记本窗口不会出现横向滚动条。 */
    min-width: 1330px;
  }

  .canvas-section {
    flex: 4;
    display: flex;
    flex-direction: column;
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(10px);
    border-radius: 12px;
    box-shadow: 0 4px 25px rgba(0, 0, 0, 0.25);
    /* 上下内边距收窄（10 → 6）：配合画布负外边距，进一步压缩画布与白线边框的上下空白，
       让下方操作栏整体上移、完整露出；左右保持 10px 不变 */
    padding: 6px 10px;
    min-height: 750px;
    border: 1px solid rgba(200, 200, 255, 0.2);
    /* 可拖拽功能栏的定位基准与层级前提：
       - position: relative 让功能栏的 absolute 定位以本区块为参照（拖到哪儿停哪儿）；
       - z-index 抬到右侧表单区之上：backdrop-filter 会创建独立堆叠上下文，
         若不抬升，功能栏被拖到表单区上方时会被表单盖住；反之两块本来左右并排，
         不存在互相遮挡的副作用。 */
    position: relative;
    z-index: 2;
  }

  /* 无星盘权限时的持久空态提示（一次 toast 容易错过，这里常驻显示） */
  .canvas-permission-notice {
    margin: 10px auto;
    padding: 12px 18px;
    max-width: 520px;
    border-radius: 8px;
    background: rgba(231, 76, 60, 0.12);
    border: 1px solid rgba(231, 76, 60, 0.35);
    color: #c0392b;
    font-size: 15px;
    line-height: 1.6;
    text-align: center;
  }

  /* 「会员租期已过」的到期时间与续费入口 */
  .canvas-permission-expiry {
    margin-top: 6px;
    font-size: 13px;
    opacity: 0.85;
  }

  .canvas-permission-renew-btn {
    margin-top: 12px;
  }

  /* 续费提示弹窗文案 */
  .renew-dialog-body {
    text-align: center;
  }

  .renew-dialog-main {
    margin: 0 0 10px;
    font-size: 16px;
    color: #c0392b;
    line-height: 1.6;
  }

  .renew-dialog-sub {
    margin: 0 0 6px;
    font-size: 13px;
    color: #666;
    line-height: 1.5;
  }

  /* 功能栏占位容器：未拖动时高度由内部功能栏（80px 高 + 10px 上外边距）撑开；
     拖动后功能栏转为绝对定位、脱离文档流，靠这里的 min-height 顶住原高度，
     避免画布区突然缩短导致页面内容跳动。 */
  .feature-toolbar-slot {
    min-height: 90px;
  }

  /* 功能栏：原为行内样式，为支持拖拽定位（需要 class 才能被动态 style / 状态类覆盖）搬到这里，
     桌面观感与改动前完全一致 */
  .feature-toolbar {
    width: fit-content;
    max-width: 90%;
    height: 80px;
    border-radius: 10px;
    background-color: #ffffff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3), 0 -2px 3px 3px rgba(0, 0, 0, 0.2) inset;
    padding: 8px 17px;
    margin: 10px auto 0;
    display: flex;
  }

  /* 拖拽手柄：功能栏左侧竖条，鼠标与手指都从这里起拖 */
  .feature-toolbar-handle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    margin-right: 10px;
    border-radius: 4px;
    color: #7f8c8d;
    background: rgba(52, 152, 219, 0.08);
    cursor: move;
    /* 手机关键：手柄上的单指手势不用于滚动 / 缩放页面，交给 JS 的 pointer 事件处理，
       否则手指一划会被判定为滑动页面，功能栏不动 */
    touch-action: none;
  }

  .feature-toolbar-handle:hover {
    color: #3498db;
    background: rgba(52, 152, 219, 0.18);
  }

  /* 拖动中：加投影强化「正被拿起」的反馈，并禁止选中文字 */
  .feature-toolbar.is-dragging {
    box-shadow: 0 8px 22px rgba(0, 0, 0, 0.35);
    user-select: none;
  }

  /* 手机上把手柄热区加宽到便于手指按住的尺寸 */
  @media (max-width: 900px) {
    .feature-toolbar-handle {
      width: 34px;
      margin-right: 8px;
    }
  }

  .button-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 15px;
    justify-content: center;
  }

  .button-row button {
    padding: 12px 30px;
    border: none;
    border-radius: 0;
    color: white;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 6px 12px rgba(0,0,0,0.4), 0 3px 6px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.3);
    min-width: 180px;
    font-size: 16px;
    letter-spacing: 1px;
    border: 2px solid rgba(0,0,0,0.2);
    border-bottom: 4px solid rgba(0,0,0,0.3);
  }

  .button-row button:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.5), 0 5px 10px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.4);
  }

  .button-row button:active {
    transform: translateY(3px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.3), inset 0 2px 4px rgba(0,0,0,0.2);
    border-bottom: 2px solid rgba(0,0,0,0.3);
  }

  /*通用css*/
  .featureList-row {
    width: 95%;
    height: 40px;
    background-color: #2b95f9;
    border-radius: 0;
    box-shadow: 0 6px 12px rgba(0,0,0,0.4), 0 3px 6px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.3);
    text-align: center;
    cursor: pointer;
    font-size: 21px;
    font-weight: 500;
    color: #f3f3f3;
    border: 2px solid rgba(0,0,0,0.2);
    border-bottom: 4px solid rgba(0,0,0,0.3);
  }
  /*悬浮样式*/
  .featureList-row:hover{
    color: #ffffff;
    background-color: #236dbd;
    box-shadow: 0 10px 20px rgba(0,0,0,0.5), 0 5px 10px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.4);
  }

  .config-action-button {
    min-width: 110px;
    height: 34px;
    padding: 0 14px;
    border: none;
    border-radius: 6px;
    background: #2ecc71;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
  }

  .config-action-button.secondary {
    background: #3498db;
  }

  .config-action-button.dirty {
    box-shadow: 0 0 0 2px rgba(241, 196, 15, 0.35);
  }
</style>
